import type { Tag } from '../types';

export const DEFAULT_TAGS: Tag[] = [
  { id: 'javascript', name: 'JavaScript', color: '#f7df1e' },
  { id: 'python', name: 'Python', color: '#3776ab' },
  { id: 'java', name: 'Java', color: '#007396' },
  { id: 'cpp', name: 'C++', color: '#f34b7d' },
  { id: 'typescript', name: 'TypeScript', color: '#3178c6' },
  { id: 'go', name: 'Go', color: '#00add8' },
  { id: 'rust', name: 'Rust', color: '#dea584' }
];